import LegalPageLayout from "../../components/LegalPageLayout";

const H2 = ({ children }) => (
  <h2 className="font-serif text-[17px] text-[#1A1A1A] font-semibold mt-8 mb-3 first:mt-0">{children}</h2>
);
const P = ({ children }) => (
  <p className="font-sans text-[14px] text-[#1A1A1A]/75 leading-[1.75] mb-3">{children}</p>
);
const Li = ({ children }) => (
  <li className="font-sans text-[14px] text-[#1A1A1A]/75 leading-[1.75] pl-1">{children}</li>
);

const DeliveryPage = () => (
  <LegalPageLayout title="Условия доставки">
    <H2>Общая информация</H2>
    <P>Все цены на сайте уже включают доставку из США до ближайшего к вам пункта выдачи СДЭК.</P>

    <H2>Доставка по регионам</H2>
    <P>Мы также доставляем заказы в любой город курьером до двери или до ближайшего пункта выдачи СДЭК.</P>
    <P>Чтобы узнать стоимость доставки до вашего города:</P>
    <ol className="list-decimal list-inside space-y-1 mb-4">
      <Li>Добавьте товар в корзину</Li>
      <Li>Укажите ваш город при оформлении заказа</Li>
    </ol>

    <H2>Сроки доставки</H2>
    <P>Чтобы обеспечить высокий уровень сервиса и приятный опыт покупки, каждый заказ проходит обязательную подготовку перед отправкой. Она включает:</P>
    <ul className="list-disc list-inside space-y-1 mb-4">
      <Li>доставку товара от бренда до нашего склада в США (если позиции нет в наличии);</Li>
      <Li>тщательную проверку на брак;</Li>
      <Li>надежную упаковку;</Li>
      <Li>передачу в службу доставки.</Li>
    </ul>
    <P>Ориентировочные сроки:</P>
    <ul className="list-disc list-inside space-y-1 mb-4">
      <Li>обработка заказа: 3–10 рабочих дней;</Li>
      <Li>доставка из США до Москвы: 7–14 рабочих дней с момента отправки;</Li>
      <Li>доставка по регионам из Москвы: зависит от удаленности вашего города.</Li>
    </ul>
    <P>В редких случаях сроки могут увеличиваться из-за задержек со стороны бренда или транспортной компании, но зачастую нам удается доставить заказы быстрее указанных сроков.</P>

    <H2>Отслеживание заказа</H2>
    <P>После передачи заказа в службу доставки вы получите email с трек-номером, по которому сможете отслеживать посылку на сайте СДЭК.</P>
  </LegalPageLayout>
);

export default DeliveryPage;
